import {ReposIssuesSidebar} from '@github-ui/repos-issues-sidebar-ui/ReposIssuesSidebar'
import {type ReactNode, useMemo} from 'react'

import type {IssuesLayoutPayload} from './issues-layout-route'

export type SidebarOptions = {
  owner: string
  repo: string
  hasProjectsEnabled: boolean
}

export function renderSidebar(options: SidebarOptions) {
  return function IssuesSidebar(collapsible?: boolean): ReactNode {
    return <ReposIssuesSidebar collapsible={collapsible} {...options} />
  }
}

// Shared source of truth for the issues sidebar render function so the parent
// (IssuesLayout) and the leaf (Labels) — only one of which consumes it depending
// on the sidebar-layout flag — can't drift apart.
export function useRenderSidebar(owner: string, repo: string, layoutPayload: IssuesLayoutPayload | undefined) {
  const hasProjectsEnabled = layoutPayload?.has_projects_enabled ?? false

  return useMemo(() => {
    return renderSidebar({
      owner,
      repo,
      hasProjectsEnabled,
    })
  }, [owner, repo, hasProjectsEnabled])
}
